export default "__VITE_ASSET__CU3851rF__"